import LandingConsumerPage from '../V3/pages/Landing-consumer/LandingConsumerPage';
import SendBackPage from '../V3/pages/SendBack/SendBackPage';
import MapPage from '../V3/pages/Map/MapPage';
import ParcelScanPage from '../V3/pages/ParcelScan/ParcelScanPage';
import DepositPage from '../V3/pages/Deposit/DepositPage';
import DepositTutorialPage from '../V3/pages/DepositTutorial/DepositTutorialPage';
import SendBackTutorialPage from '../V3/pages/SendBackTutorial/SendBackTutorialPage';
import BravoPage from '../V3/pages/WellDone/WellDonePage';
import SelectParcelPage from '../V3/pages/SelectParcel/SelectParcelPage';

export const v3Routes = [
  { path: '/', element: <LandingConsumerPage /> },
  { path: 'reception', element: <SelectParcelPage /> },
  { path: 'retour', element: <SelectParcelPage /> },
  { path: 'sendback', element: <SendBackPage /> },
  { path: 'map', element: <MapPage /> },
  { path: 'sendback/map', element: <MapPage /> },
  { path: 'scan', element: <ParcelScanPage /> },
  { path: 'deposit', element: <DepositPage /> },
  { path: 'deposit/tutorial', element: <DepositTutorialPage /> },
  { path: 'sendback/tutorial', element: <SendBackTutorialPage /> },
  { path: 'welldone', element: <BravoPage /> },

  // Entrée QR code — parcelId dans l'URL uniquement pour la landing
  { path: ':parcelId', element: <LandingConsumerPage /> },
];
